import React from 'react';
import Combaintop from '../Components/Combaintop/Top';
import Combainbottom from '../Components/Combainbottom/Combainbottom';
import OrderHistory from '../Components/User-Dashboard/OrderDetail';
import Breadcrumbs from '../Components/banner/New-banner';

function Orderpage () {
    return(
        <>
        <Combaintop/>
        <Breadcrumbs/>
        <OrderHistory/>
        <Combainbottom/>
        </>
    );
}
export default Orderpage;